"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleFieldByConfig = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _utils = require("../../../utils");
var _jsxRuntime = require("react/jsx-runtime");
const ToggleFieldByConfig = props => {
  const {
    name,
    label,
    isEditable,
    isAvailable,
    displayOrder,
    validation,
    initialValue,
    onChange,
    options,
    isDisabled
  } = props;
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    setValue
  } = (0, _reactHookForm.useFormContext)();
  const regexPattern = validation?.regularExpression ? new RegExp(validation.regularExpression) : undefined;
  const availableOptions = [];
  if (options[0] && options[1]) {
    availableOptions.push({
      label: options[0],
      value: false
    }, {
      label: options[1],
      value: true
    });
  }
  const getValue = value => {
    if (availableOptions[0] && availableOptions[1]) {
      if (value?.toUpperCase() === availableOptions[1].label.toUpperCase()) {
        return availableOptions[1].value;
      }
      return availableOptions[0].value;
    }
    return false;
  };
  (0, _react.useEffect)(() => {
    if (initialValue === '' || initialValue === undefined) {
      setValue(name, options[0]);
    }
  }, [initialValue, name, options, setValue]);
  if (!isAvailable) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
    size: {
      xs: 12,
      sm: 12
    },
    style: {
      order: displayOrder
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box, {
      mb: 4,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHookForm.Controller, {
        name: name,
        rules: {
          required: validation?.isMandatory,
          maxLength: validation?.maxLength,
          minLength: validation?.minLength,
          pattern: regexPattern
        },
        defaultValue: initialValue,
        render: ({
          field
        }) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.FormControl, {
          fullWidth: true,
          sx: {
            marginBottom: 0
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
            variant: "overline",
            align: "left",
            children: [label, " ", validation?.isMandatory ? ' *' : null]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Toggle, {
            fullWidth: true,
            checked: getValue(field.value),
            firstText: availableOptions[0] ? availableOptions[0].label : '',
            secondText: availableOptions[1] ? availableOptions[1].label : '',
            disabled: isDisabled || !isEditable,
            "data-testid": getTestId((0, _utils.camelCaseToKebabCase)(name)),
            onChange: ({
              currentTarget: {
                checked
              }
            }) => {
              if (availableOptions[0] && availableOptions[1]) {
                field.onChange(checked ? availableOptions[1].label : availableOptions[0].label);
                onChange?.(checked ? availableOptions[1].label : availableOptions[0].label);
              }
            }
          })]
        })
      })
    })
  });
};
exports.ToggleFieldByConfig = ToggleFieldByConfig;
//# sourceMappingURL=ToggleFieldByConfig.js.map